<template>
  <div>
    <div class="container">
      <div class="box--title">
        <h1 class="title-home">
          Track Movies & TV Shows You've Watched <br />
          Organize your Watchlist
        </h1>
        <ith-cards-watch />
        <div id="movies"></div>
      </div>
      <div class="title-linea-container">
        <div class="title-linea">
          <div class="title">{{ title.movies }}</div>
          <div class="linea"></div>
        </div>
      </div>

      <ith-movies-grid-detail />
    </div>

    <ith-banner :item="banner" />

    <div class="container">
      <div class="title-linea-container">
        <div class="title-linea">
          <div id="series"></div>
          <div class="title">{{ title.series }}</div>
          <div class="linea"></div>
        </div>

        <ith-series-grid-detail />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["title"]),
  data: () => ({
    parametros: [],
    banner: {
      title: "",
      text: "",
      image: "./img/banners/MUSTWATCH_IMAGE.png",
      btn: true
    }
  })
};
</script>

<style scoped>
.box--title {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
}
h2 {
  margin: 0px;
}

.title-home {
  font-size: 25px;
}

.title-linea {
  margin-top: 35px;
  width: 100%;
  display: flex;
  height: 70px;
  column-gap: 20px;
  align-items: flex-start;
}

.title {
  align-self: center;
  white-space: nowrap;
  font-size: 1.2em;
}
.linea {
  width: 100%;
  height: 50%;
  border-bottom: 1px solid #738092;
}

#series {
  position: absolute;
  top: -70px;
}
#movies {
  position: absolute;
  top: 60px;
}
.title-linea-container {
  position: relative;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .title {
    margin: 0px 10px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .title {
    margin: 0px 10px;
    padding-top: 0px;
    font-size: 17px;
  }
  #movies {
    top: 20px;
  }
}

@media (max-width: 600px) {
  .title-home {
    padding: 0px 10px;
    padding-top: 0px;
    font-size: 15px;
  }
  #movies {
    top: 20px;
  }
  .title-linea-container {
    margin-left: 10px;
  }

  .box--title {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);
    row-gap: 20px;
  }
}
</style>
